import React from "react";
import UseContext from "hooks/useContext";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import SummaryField from "components/summaryField/SummaryField";
import {
    SUMMARY_ROWS,
    buildSummaryFromWizardData,
} from "pages/missionTemplates/components/MissionTemplateSummary";
import {
    TEMPLATE_STEP,
    getTemplateStepPage,
} from "pages/missionTemplates/templateSteps";
import { useRiskyPositions } from "pages/missionTemplates/utils/templateRiskyPositions";

/** Which step owns each line of the summary, so its pencil leads back there. */
const STEP_BY_FIELD = {
    name: TEMPLATE_STEP.ACTIVITY,
    activity: TEMPLATE_STEP.ACTIVITY,
    qualification: TEMPLATE_STEP.ACTIVITY,
    riskyPosition: TEMPLATE_STEP.RISKY_POSITION,
    tools: TEMPLATE_STEP.PREREQUIS,
    licences: TEMPLATE_STEP.PREREQUIS,
    languages: TEMPLATE_STEP.PREREQUIS,
    address: TEMPLATE_STEP.LOCATION_SALARY,
    salary: TEMPLATE_STEP.LOCATION_SALARY,
    contact: TEMPLATE_STEP.INFO,
    other: TEMPLATE_STEP.INFO,
    otherInterim: TEMPLATE_STEP.INFO,
};

const ConfirmationTemplate = () => {
    const { templateData, setTemplatePage, language } = UseContext();
    const { riskyPositions } = useRiskyPositions();
    const summary = buildSummaryFromWizardData(
        templateData,
        language,
        riskyPositions
    );
    const editLabel = language.getValue(
        "missionTemplate.confirmation.edit",
        "Modifier"
    );

    return (
        <SectionWrapper
            title="Confirmation"
            description="Vérifiez les informations de la fiche de poste avant de l'enregistrer."
        >
            <div className={"flex flex-col"}>
                {SUMMARY_ROWS.map(({ key, defaultLabel }) => {
                    const label = language.getValue(
                        `missionTemplate.preview.fields.${key}`,
                        defaultLabel
                    );
                    return (
                        <SummaryField
                            key={key}
                            label={label}
                            value={summary[key]}
                            editLabel={`${editLabel} : ${label}`}
                            onEdit={() =>
                                setTemplatePage(
                                    getTemplateStepPage(STEP_BY_FIELD[key])
                                )
                            }
                        />
                    );
                })}
            </div>
        </SectionWrapper>
    );
};

export default ConfirmationTemplate;
